<app-dialog-container 
    [showCloseButton]="false"
    [noContentPadding]="true"
>

    <ng-container dialog-header>
        <h4>Site Preview</h4>
    </ng-container>

    <ng-container dialog-content>
        <app-viewer/>
    </ng-container>

    <ng-container dialog-actions>
        <app-button data-dialog-close [disabled]="loading">
            Back
        </app-button>
        <app-button
        [disabled]="loading"
        (event)="import(true)"
        >
            {{loading ? 'Loading' : 'Import & Edit'}}
        </app-button>
        <app-button
        [disabled]="loading"
        (event)="import()"
        >
            {{loading ? 'Loading' : 'Import'}}
        </app-button>
    </ng-container>

</app-dialog-container>